import ForgetPassword from "./ForgetPassword.jsx";

export default ForgetPassword;
